import React from "react";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default function CustomInput(props) {
  return (
    <>
      <span style={{ color: "#80949D" }}>{props?.label}</span>
      <Form.Group controlId={props?.id}>
        <Form.Control
          type={props.type}
          style={props.style}
          placeholder={props?.placeholder}
          defaultValue={props?.value}
          onChange={props?.onChange}
          required={props.required}
          maxLength={props?.maxLength}
        />

        <Form.Text className="text-danger">{props.errorText}</Form.Text>
      </Form.Group>
    </>
  );
}

// How to use

{
  /* <CustomInput
type={'text'}
label={'Organization Name :'}
placeholder={'Enter Organization Name'}
/> */
}
